import RespondentStepper from "./RespondentStepper";

export default RespondentStepper;
